import {createMuiTheme} from "@material-ui/core/styles";

const defaultTheme = createMuiTheme();

export default {
    overrides: {
        MuiContainer: {
            root: {
                [defaultTheme.breakpoints.up('sm')]: {
                    paddingLeft: '20px',
                    paddingRight: '20px'
                }
            }
        },
        MuiButton: {
            root: {
                fontSize: '.929rem',
                borderRadius: '.571rem',
                padding: '5px 16px 5px 16px',
                "text-transform": "unset",
            },
            outlined: {
              padding: "4px 16px"
            },
            contained: {
                '&.Mui-disabled': {background: "rgba(0, 0, 0, 0.12)"}
            },
            containedSizeLarge: {
                padding: "5px 16px 6px 16px",
                fontSize: '1rem'
            },
            containedSizeSmall: {
                padding: "3px 16px 4px 16px",
                fontSize: ".929rem",
            },
            outlinedSizeSmall: {
                fontSize: ".929rem",
            },
            outlinedSizeLarge: {
              padding: "6px 16px",
              fontSize: ".929rem"
            },
            containedPrimary: {
                borderRadius: '.571rem',
                backgroundColor: 'var(--primary)',
                '&:hover': {
                    backgroundColor: 'var(--primary)',
                    '@media (hover: none)': {
                        backgroundColor: 'var(--primary)',
                    },
                }
            },
            containedSecondary: {
                borderRadius: '.571rem',
                backgroundColor: '#3D4977',
                '&:hover': {
                    backgroundColor: '#3D4977!important',
                    '@media (hover: none)': {
                        backgroundColor: '#3D4977',
                    },
                }
            },
            outlinedSecondary: {
                color: "#3D4977",
                border: "1px solid rgba(61,73,119, 0.5)",
                '&:hover': {
                    border: "1px solid #3D4977",
                    backgroundColor: "rgba(61,73,119, 0.04)",
                    '@media (hover: none)': {
                        backgroundColor: 'rgba(61,73,119, 0.04)',
                    }
                }
            },
        },
        MuiStepIcon: {
            root: {
                color: 'rgba(0, 0, 0, 0.54)',
                "&$active": {
                    color: 'var(--primary)'
                },
            }
        },
        MuiOutlinedInput: {
            root: {
                borderRadius: 10,
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'var(--primary)',
                },
            },
        },
        MuiInputLabel: {
            root: {
                '&.Mui-focused': {
                    color: 'var(--primary)'
                }
            }
        },
        MuiCheckbox: {
            colorSecondary: {
                '&.Mui-checked': {
                    color: 'var(--primary)',
                    '&:hover': {
                        backgroundColor: 'rgba(46, 160, 220, 0.04)!important'
                    }
                },
                '&:hover': {
                    backgroundColor: 'rgba(46, 160, 220, 0.04)'
                }
            }
        },
        MuiAlert: {
            root: {
                borderRadius: '.571rem',
                fontSize: '1rem',
                [defaultTheme.breakpoints.down('sm')]: {
                    padding: '6px 8px'
                }
            },
            icon: {
                marginRight: '8px'
            },
            standardWarning: {
                backgroundColor: '#FDF1EA'
            }
        },
        MuiPaper: {
            rounded: {
                borderRadius: '10px',
            }
        },
        MuiFormLabel: {
            root: {
                '&.Mui-error': {
                    color: 'var(--grey-text)'
                }
            }
        },
        MuiTypography: {
            body1: {
                color: 'var(--grey-text)'
            }
        },
        MuiFormHelperText: {
            root: {
                '&.Mui-error': {
                    '&::first-letter': {
                        textTransform: 'capitalize'
                    }
                }
            }
        },
        MuiSkeleton: {
            root: {
                backgroundColor: '#F4F5FD'
            },
            pulse: {
                animation: undefined
            }
        },
        MuiAutocomplete: {
            inputRoot: {
                height: '56px'
            }
        },
        MuiSvgIcon: {
            root: {
                fontSize: '1.72rem'
            }
        },
        MuiDialog: {
            paper: {
                margin: '18px',
            }
        }
    }
}
